import { DateInt12, DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Partner } from './partner.model';

@CwtModel({ name: 'announcement', path: '/announcement' })
export class Announcement extends ApiData {
    title?: DictionaryObject;
    content?: DictionaryObject;
    startDate?: DateInt12;
    endDate?: DateInt12;
    partner?: Partner;


    startDateObject: Date;
    endDateObject: Date;

    fieldDictionary() {
        return {
            partner: Partner,
            startDateObject: Date,
            endDateObject: Date,
        };
    }
}
